import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { Icon, Label } from '@atlas/ui';

import useFormatter from 'src/hooks/useFormatter';

import useBonusCancelDetails from './useBonusCancelDetails';

const BonusCancelDetailsTable = ({ bonus, wallet }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const details = useBonusCancelDetails(bonus, wallet);
  const { currencyFormatter } = useFormatter(wallet?.currency);

  const toggleExpanded = useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);

  if (!bonus) return null;

  return (
    <div className="bonus-cancel-popup__details">
      <button className="bonus-cancel-popup__details-toggle" onClick={toggleExpanded} type="button">
        <Label message="cancel_bonus_details" />
        <Icon name={isExpanded ? 'arrow-up' : 'arrow-down'} />
      </button>

      {isExpanded && (
        <div className="bonus-cancel-popup__details-content">
          <div className="bonus-cancel-popup__details-section">
            <Label className="bonus-cancel-popup__details-heading" message="cancel_bonus_before" />
            {details.before.cash && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="cash" />
                <span>{currencyFormatter.format(details.values.cash)}</span>
              </div>
            )}
            {details.before.lockedCash && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="locked_cash" />
                <span>{currencyFormatter.format(details.values.lockedCash)}</span>
              </div>
            )}
            {details.before.bonus && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="bonus" />
                <span>{currencyFormatter.format(details.values.bonus)}</span>
              </div>
            )}
            {details.before.bonusWinnings && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="bonus_winnings" />
                <span>{currencyFormatter.format(details.values.bonusWinnings)}</span>
              </div>
            )}
            {details.before.freeSpins && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="free_spins" />
                <span>{details.values.freeSpins}</span>
              </div>
            )}
            {details.before.wageringLeft && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="wagering_left" />
                <span>{currencyFormatter.format(details.values.wageringLeft)}</span>
              </div>
            )}
          </div>

          <div className="bonus-cancel-popup__details-section">
            <Label className="bonus-cancel-popup__details-heading" message="cancel_bonus_after" />
            {details.after.keepCash && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="keep_cash" />
                <span>{currencyFormatter.format(details.values.keepCash)}</span>
              </div>
            )}
            {details.after.forfeit && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="forfeit" />
                <span>{currencyFormatter.format(details.values.forfeit)}</span>
              </div>
            )}
            {details.after.freeSpinsRemoved && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="free_spins_removed" />
                <span>{details.values.freeSpins}</span>
              </div>
            )}
            {details.after.wageringReset && (
              <div className="bonus-cancel-popup__details-row">
                <Label message="wagering_reset" />
                <span>0</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

BonusCancelDetailsTable.propTypes = {
  bonus: PropTypes.object,
  wallet: PropTypes.object,
};

export default BonusCancelDetailsTable;
